<div class="content">
  <mat-progress-bar
    *ngIf="isLoading"
    mode="indeterminate"
    color="primary"
  ></mat-progress-bar>
  <div class="card" style="margin-top: 0">
    <div class="card-content">
      <div class="card-body">
        <button
          *ngIf="!isList"
          routerLink="/yearperiods"
          title="{{ 'inputs.back' | translate }}"
          mat-icon-button
        >
          <mat-icon>keyboard_backspace</mat-icon>
          {{ "inputs.back" | translate }}
        </button>

        <h1 *ngIf="isList">{{ "titles.list.yearperiod" | translate }}</h1>
        <h1 *ngIf="!isList">{{ "titles.edit.yearperiod" | translate }}</h1>
        <div *ngIf="!isList && !isNew">
          {{ "inputs.creation_date" | translate }}:
          {{ creation_date | date: "d/M/Y, H:mm:ss" }} <br />
          {{ "inputs.modification_date" | translate }}:
          {{ modification_date | date: "d/M/Y, H:mm:ss" }}
        </div>

        <div class="media-body">
          <mat-form-field *ngIf="isList">
            <mat-label>{{ "inputs.search" | translate }}</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="{{ 'inputs.search' | translate }}"
              #input
            />
          </mat-form-field>
          <div *ngIf="isList">
            <table mat-table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "tables.name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                >
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="activated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "tables.activated" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                >
                  {{ "tables." + element.activated | translate }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modification_date">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  {{ "tables.modification_date" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                  fxHide.lt-sm
                >
                  {{ element.modification_date | date: "yyyy-MM-dd H:mm:ss" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.actions" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- <button mat-icon-button matTooltip="Click to Delete related information" class="iconbutton"
                    (click)="delete(element.id)" color="warn">
                    <mat-icon>delete</mat-icon>
                  </button> -->
                  <button
                    mat-icon-button
                    matTooltip="{{ 'inputs.edit' | translate }}"
                    (click)="goTo(element.id)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  <span *ngIf="showYearperiodProgressBar">{{
                    "tables.loading" | translate
                  }}</span>
                  <span *ngIf="!showYearperiodProgressBar">{{
                    "tables.no_data_found" | translate
                  }}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar
              *ngIf="showYearperiodProgressBar"
              mode="indeterminate"
            ></mat-progress-bar>

            <mat-paginator
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="[100, 10, 20, 50]"
              showFirstLastButtons
            ></mat-paginator>
          </div>

          <!-- <mat-card *ngIf='!isList'> -->
          <div class="contenedor" [formGroup]="yearperiodForm" *ngIf="!isList">
            <input
              matInput
              [hidden]="true"
              [formControlName]="'id'"
              type="text"
              placeholder="id"
            />
            <mat-form-field>
              <input
                matInput
                required
                [formControlName]="'name'"
                type="text"
                placeholder="{{ 'inputs.name' | translate }}"
              />
            </mat-form-field>

            <!-- <mat-checkbox [formControlName]="'activated'" [color]="'primary'"
              >{{ "inputs.activated" | translate }}
            </mat-checkbox> -->

            <mat-slide-toggle
              #slider
              color="primary"
              (change)="onSliderToggle(slider)"
              [checked]="isEnabled"
              [disabled]="isLoading"
            >
              {{
                (isEnabled ? "status.enabled" : "status.disabled") | translate
              }}
            </mat-slide-toggle>
          </div>
          <!-- </mat-card> -->

          <div class="float-button-container" *ngIf="isList">
            <button
              mat-fab
              color="primary"
              aria-label="add"
              (click)="newYearperiod()"
            >
              <mat-icon>plus_one</mat-icon>
            </button>
          </div>
          <div class="float-button-container" *ngIf="!isList">
            <button
              mat-fab
              color="primary"
              aria-label="save"
              (click)="saveYearperiod()"
            >
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
